/**
 * Shared CrewPilot desktop page canvas helpers (command / hub categories).
 * CSS: `src/layout/desktopPage.css` (imported from App.js).
 * Broader page categories / grids: `src/layout/pageLayout.js`.
 */

/** Class name for the standard desktop hub canvas. */
export const DESKTOP_PAGE_CLASS = "cp-desktop-page";

/**
 * Compose className with the desktop page canvas when enabled.
 * @param {string} [className]
 * @param {boolean} [enabled=true]
 */
export function withDesktopPageClass(className = "", enabled = true) {
  if (!enabled) {
    return className || "";
  }
  return [DESKTOP_PAGE_CLASS, className].filter(Boolean).join(" ");
}
